module.exports = __webpack_public_path__ + "static/media/intro2.731947aa.png";